import { DatePipe } from '@angular/common';
import { TranslatePipe } from '../../filters/translate.pipe';
import { LoaderOverlayComponent } from '../../components/loader-overlay/loader-overlay.component';
import { Component, OnInit, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import Session from '../../utils/session.service';
import RestService from '../../services/core-rest.service';
import AngularFilterHelperService from '../../services/angular-filter-helper.service';
import { Input, Output, EventEmitter } from '@angular/core';

@Component({
	standalone: true,
	selector: 'item-pre-visit-ticket-info',
	templateUrl: './item-pre-visit-ticket-info.component.html',
	imports: [ CommonModule, DatePipe, TranslatePipe, LoaderOverlayComponent, FormsModule ]
})
export class ItemPreVisitTicketInfoComponent implements OnInit {
	private session: Session = inject(Session);
	private restService: RestService = inject(RestService);
	private angularFilterHelperService: AngularFilterHelperService = inject(AngularFilterHelperService);
	
	@Input() original: any;
	@Output() originalChange: EventEmitter<any> = new EventEmitter<any>(); // TODO ANGULAR_2: fix calling event emitter
	@Input() isAlt: any | undefined;
	@Input() onSave: any | undefined;
	@Output() onSaveChange: EventEmitter<any> = new EventEmitter<any>(); // TODO ANGULAR_2: fix calling event emitter
	@Input() ticket: any;
	@Output() ticketChange: EventEmitter<any> = new EventEmitter<any>(); // TODO ANGULAR_2: fix calling event emitter
	
	vm: any = undefined;
	
	constructor() {
		this.vm = this;
	}
	
	ngOnInit() {
		this.initialize();
	}
	
	initialize() {
		if (!this.vm.ticket) return;
		this.vm.user = this.session.getSession().user;
		this.vm.uid = 'pti-' + Date.now();
		
		this.vm.enumTranslations = {
			'NEW_HEALTH_PROBLEM': this.angularFilterHelperService.translate('PreVisit.User_Tickets.NEW_HEALTH_PROBLEM'),
			'PRESCRIPTION_RENEW_REQUEST': this.angularFilterHelperService.translate('PreVisit.User_Tickets.PRESCRIPTION_RENEW_REQUEST'),
			'HEALTH_CERTIFICATE_REQUEST': this.angularFilterHelperService.translate('PreVisit.User_Tickets.HEALTH_CERTIFICATE_REQUEST'),
			'HEALTH_CHECKUP_REQUEST': this.angularFilterHelperService.translate('PreVisit.User_Tickets.HEALTH_CHECKUP_REQUEST'),
			'VACCINATION_REQUEST': this.angularFilterHelperService.translate('PreVisit.User_Tickets.VACCINATION_REQUEST'),
			'NEW_PRESCRIPTION_REQUEST': this.angularFilterHelperService.translate('PreVisit.User_Tickets.NEW_PRESCRIPTION_REQUEST'),
			'CHILD_RELATED_REQUEST': this.angularFilterHelperService.translate('PreVisit.User_Tickets.CHILD_RELATED_REQUEST'),
			'CHRONICALLY_ILL_VISIT_REQUEST': this.angularFilterHelperService.translate('PreVisit.User_Tickets.CHRONICALLY_ILL_VISIT_REQUEST'),
			'SICK_LEAVE_CERTIFICATE_REQUEST': this.angularFilterHelperService.translate('PreVisit.User_Tickets.SICK_LEAVE_CERTIFICATE_REQUEST'),
			'FOLLOW_UP_REQUEST': this.angularFilterHelperService.translate('PreVisit.User_Tickets.FOLLOW_UP_REQUEST'),
			'CHRONICALLY_ILL_PRESCRIPTION_REQUEST': this.angularFilterHelperService.translate('PreVisit.User_Tickets.CHRONICALLY_ILL_PRESCRIPTION_REQUEST'),
			'REFERRAL_LETTER_TO_PSYCHOLOGIST': this.angularFilterHelperService.translate('PreVisit.User_Tickets.REFERRAL_LETTER_TO_PSYCHOLOGIST'),
			'MENTAL_HEALTH_CONSULTATION_REPORT': this.angularFilterHelperService.translate('PreVisit.User_Tickets.MENTAL_HEALTH_CONSULTATION_REPORT'),
			'CREATED': this.angularFilterHelperService.translate('PreVisit.User_Tickets.CREATED'),
			'SENT': this.angularFilterHelperService.translate('PreVisit.User_Tickets.SENT'),
			'REFERRED_PRACTICE': this.angularFilterHelperService.translate('PreVisit.User_Tickets.SENT'),
			'PARTNER_SYSTEM_CONFIRMED_RECEIVED': this.angularFilterHelperService.translate('PreVisit.User_Tickets.SENT'),
			'REQUIRES_REGISTRATION': this.angularFilterHelperService.translate('PreVisit.User_Tickets.REQUIRES_REGISTRATION'),
			'BOOKED': this.angularFilterHelperService.translate('PreVisit.User_Tickets.BOOKED'),
			'COMPLETED': this.angularFilterHelperService.translate('PreVisit.User_Tickets.COMPLETED'),
			'CANCELED': this.angularFilterHelperService.translate('PreVisit.User_Tickets.CANCELED'),
			'CANCELED_ERROR': this.angularFilterHelperService.translate('PreVisit.User_Tickets.CANCELED'),
			'CANCELED_SENT': this.angularFilterHelperService.translate('PreVisit.User_Tickets.CANCELED'),
			'CANCELED_CONFIRMED': this.angularFilterHelperService.translate('PreVisit.User_Tickets.CANCELED'),
			'REJECTED': this.angularFilterHelperService.translate('PreVisit.User_Tickets.REJECTED'),
			'MEDIPOST_SEND_ERROR': this.angularFilterHelperService.translate('PreVisit.User_Tickets.ERROR'),
			'INTERNAL_ERROR': this.angularFilterHelperService.translate('PreVisit.User_Tickets.ERROR'),
			'PARTNER_SYSTEM_PROCESSING_FAILED': this.angularFilterHelperService.translate('PreVisit.User_Tickets.ERROR'),
			'PARTNER_SYSTEM_TRANSIENT_ERROR': this.angularFilterHelperService.translate('PreVisit.User_Tickets.ERROR'),
			'FREE_TEXT_PROBLEM_DESCRIPTION': this.angularFilterHelperService.translate('PreVisit.Symptom_Check.Free_Text_Problem_Description_Title')
		};
		
		this.vm.isTicketDataDisplayed = (ticketData) => {
			if (ticketData.config.fieldName === "INFERMEDICA_INTERVIEW_ID") {
				return false;
			} else {
				return true;
			}
		}
		
		this.restService.getPreVisitTicketGetData({ ticketId: this.vm.ticket.id })
			.then((res) => {
				this.vm.ticketDatas = res;
				this.vm.ticketDatas.forEach(ticketData => {
					if (ticketData.config.type === "CHECKBOX" || ticketData.config.type === "RADIO") {
						if (ticketData.content === "true") {
							ticketData.cleanedContent = this.angularFilterHelperService.translate('Common.Yes');
						} else {
							ticketData.cleanedContent = this.angularFilterHelperService.translate('Common.No');
						}
					} else {
						const content = ticketData.content || '';
						const linkRegex = /https:\/\/s3-eu-west-1\.amazonaws\.com\/[^\s"]+/g;
						const foundLinks = content.match(linkRegex);
	
						if (foundLinks) {
							if (!this.vm.links) {
								this.vm.links = [];
							}
							this.vm.links.push(...foundLinks);
							ticketData.cleanedContent = content.replace(linkRegex, '').replace(/\s{2,}/g, ' ').trim();
						} else {
							ticketData.cleanedContent = content;
						}
					}
				});
				this.vm.initialized = true;
				this.vm.loading = false;
			}).catch((err) => {
				this.vm.initialized = true;
				this.vm.loading = false;
			});
	}
	
}